"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOutFirebase = exports.signInToFirebase = void 0;
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("firebase/auth");
const config_1 = require("./config");
const FALLBACK_TOKEN_ENDPOINT = `${(_a = process.env.API_URL) !== null && _a !== void 0 ? _a : ""}/firebase/custom-token`;
function signInToFirebase(email, _password, apiToken) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios_1.default.post(FALLBACK_TOKEN_ENDPOINT, { email }, apiToken
                ? {
                    headers: {
                        authorization: `Bearer ${apiToken}`,
                    },
                }
                : undefined);
            const token = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.token;
            if (token) {
                yield (0, auth_1.signInWithCustomToken)(config_1.auth, token);
                return true;
            }
        }
        catch (fallbackErr) {
            console.error("Firebase custom token sign-in failed:", fallbackErr);
        }
        return false;
    });
}
exports.signInToFirebase = signInToFirebase;
function signOutFirebase() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield (0, auth_1.signOut)(config_1.auth);
        }
        catch (err) {
            console.warn("Firebase sign-out failed (safe to ignore):", err);
        }
    });
}
exports.signOutFirebase = signOutFirebase;
